import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Banner } from 'appkit-react';
import commonActions from '@flux/action/common';
import './globalBannerStyle.scss';

function GlobalBanner() {
  const dispatch = useDispatch();
  const { visible, content, status, ...restProps } = useSelector(
    ({ common, projects }) => common?.banner,
  );
  const onClose = useCallback(() => {
    dispatch(commonActions.closeBanner());
  }, []);
  return visible ? (
    <Banner
      className="global-banner"
      content={content}
      status={status}
      onClose={onClose}
      {...restProps}
    />
  ) : null;
}

export default GlobalBanner;
